import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=ba638e0e&scoped=true&"
import script from "./Products.vue?vue&type=script&lang=js&"
export * from "./Products.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba638e0e",
  null
  
)

export default component.exports
import {QBreadcrumbs,QBreadcrumbsEl,QBtn,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QInput,QTable,QTr,QTh,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBreadcrumbs,QBreadcrumbsEl,QBtn,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QInput,QTable,QTr,QTh})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
